<template>
  <div class="opt-record">
    <el-card :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <appTable
          :tableProps="tableProps"
          :tableData="tableData"
          :selectCtrl="false"
        />
      </div>
      <pagination
        :pageSize="params.pageSize"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
  </div>
</template>

<script>
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import api from "@/api";

export default {
  name: "OptRecord",
  components: {
    appTable,
    pagination
  },
  props: {
    detailId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 20
      },
      tableData: [],
      total: 0
    };
  },
  computed: {
    tableProps() {
      return [
        {
          prop: "user",
          label: "操作人",
          formatter: (row) => {
            return row.user ? row.user.nickname : "-";
          }
        },
        {
          prop: "operation",
          label: "操作",
          formatter: (row) => {
            return row.operation === "edit" ? "更新" : "新增";
          }
        },
        {
          prop: "createdAt",
          label: "操作时间"
        }
      ];
    }
  },
  watch: {
    detailId: {
      immediate: true,
      handler() {
        if (this.detailId) {
          this.getList();
        }
      }
    }
  },
  methods: {
    getList() {
      if (!this.detailId) return;
      api
        .getStickerOptRecord(this.detailId, this.params)
        .then((res) => {
          this.tableData = res.data.items || [];
          this.total = res.data.count || 0;
        })
        .catch((err) => {
          this.$message.error(err.message || "获取操作记录失败");
        });
    },
    getPageNum(page) {
      this.params.page = page;
      this.getList();
    }
  }
};
</script>

<style scoped>
.opt-record {
  padding: 20px;
}
</style>

